<router-outlet></router-outlet>
@if (loading()) {
  <div class="grid items-center justify-center w-full h-screen backdrop-blur-[1px] bg-white/50 absolute top-0 left-0">
    <lib-spinner class="size-20 text-brand-500" name="crescent"></lib-spinner>        
  </div>    
}